import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import AspectRatio from 'components/ui/AspectRatio'
import Image from 'components/ui/Image'

import s from './ImageSlice.module.scss'

const cn = classNames.bind(s)

const ImageSlice = ({ data }) => {
  const image = data?.primary?.imageSharp?.childImageSharp ? data?.primary?.imageSharp : data?.primary?.image

  if (!image) return null

  let ratio = 0.5625

  if (image.childImageSharp?.fluid?.aspectRatio) {
    ratio = image.childImageSharp?.fluid?.aspectRatio
  } else {
    // this is probably a GIF ?
    ratio = (Math.round((image.dimensions?.width / image.dimensions?.height) * 100) / 100).toFixed(2)
    ratio = parseFloat(ratio)
  }

  const altText = data?.primary?.image?.alt || ''

  return (
    <div className={cn('container')}>
      <div className={cn('wrapper')}>
        <AspectRatio className={cn('stretch')} ratio={ratio} mediumRatio={ratio} desktopRatio={ratio}>
          <Image src={data?.primary?.imageSharp ? image : image.url} alt={altText} className={cn('image')} />
        </AspectRatio>
      </div>
    </div>
  )
}

ImageSlice.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ImageSlice
